import { CreditCard, Trash2, Check, ChevronDown } from "lucide-react";

export const Icons = {
  creditCard: CreditCard,
  trash: Trash2,
  check: Check,
  chevronDown: ChevronDown,
} as const;
